// runtime/source/site/media/media.js
function initMedia() {
  const lifetime = new AbortController();
  const status = document.querySelector("[data-download-status]");
  for (const button of document.querySelectorAll("[data-logo-download]")) {
    button.addEventListener("click", async () => {
      button.disabled = true;
      status.textContent = "";
      try {
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.src = button.dataset.source;
        await image.decode();
        const canvas = document.createElement("canvas");
        canvas.width = 880;
        canvas.height = 1700;
        const context = canvas.getContext("2d");
        if (!context) throw new Error("Canvas unavailable");
        const format = button.dataset.logoDownload;
        if (format === "jpeg") {
          context.fillStyle = button.dataset.color === "white" ? "#1b1b1b" : "#ffffff";
          context.fillRect(0, 0, canvas.width, canvas.height);
        }
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        const blob = await new Promise((resolve) => canvas.toBlob(resolve, `image/${format}`, 0.96));
        if (!blob) throw new Error("Export unavailable");
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `BOXBOX-${button.dataset.color}.${format === "jpeg" ? "jpg" : "png"}`;
        document.body.append(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 3e4);
        canvas.width = canvas.height = 0;
        status.textContent = `${button.dataset.color === "white" ? "White" : "Black"} logo ${format.toUpperCase()} download prepared.`;
      } catch {
        status.textContent = "That export could not be prepared. Please use the SVG download or contact media@boxbox.com.";
      } finally {
        button.disabled = false;
      }
    }, { signal: lifetime.signal });
  }
  return () => lifetime.abort();
}

// runtime/media.js
var dispose = initMedia();
document.addEventListener("shopify:section:unload", () => dispose());
document.addEventListener("shopify:section:load", () => {
  dispose();
  dispose = initMedia();
});
